// Lets any link (Elementor button, header submenu item, …) tag the click
// with a title + source, without touching the URL — the landing page then
// swaps in that title and forwards the source into a Gravity Forms hidden
// field. data-lp-title / data-lp-source get onto the link either via
// Elementor's own "Custom Attributes" control (buttons) or the "Lead Title" /
// "Lead Source" ACF fields on nav menu items (see inc/acf.php, inc/menu.php).
//
// A third value, email, works the same way but comes from a plain
// <input type="email"> sitting next to the link (in a shared .it-email-cta
// wrapper) instead of a data attribute, since it's typed in at click time
// rather than configured ahead of time.
const COOKIE_TITLE = 'lp_title';
const COOKIE_SOURCE = 'lp_source';
const COOKIE_EMAIL = 'lp_email';
// Long enough to survive the redirect + any interstitial, short enough that
// an unrelated visit an hour later doesn't inherit stale attribution.
const COOKIE_MAX_AGE = 30 * 60;

function setCookie(name, value) {
    document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + COOKIE_MAX_AGE + '; SameSite=Lax';
}

function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
}

function deleteCookie(name) {
    document.cookie = name + '=; path=/; max-age=0';
}

// Click capture: works from any descendant of the tagged element (icon,
// text span, …) since it walks up via closest(); no preventDefault needed
// because the cookie write finishes before the browser follows the href.
export function initLeadSourceCapture() {
    document.addEventListener('click', function (e) {
        var link = e.target.closest('[data-lp-title], [data-lp-source]');

        if (!link) {
            return;
        }

        var title = link.getAttribute('data-lp-title');
        var source = link.getAttribute('data-lp-source');
        var emailWrapper = link.closest('.it-email-cta');
        var emailInput = emailWrapper ? emailWrapper.querySelector('input[type="email"]') : null;

        if (title) {
            setCookie(COOKIE_TITLE, title);
        }

        if (source) {
            setCookie(COOKIE_SOURCE, source);
        }

        if (emailInput && emailInput.value) {
            setCookie(COOKIE_EMAIL, emailInput.value);
        }
    });
}

// Landing-page side: swap the Elementor heading marked with
// data-lp-title-target and fill any Gravity Forms field marked with the
// lp-source-field / lp-email-field classes, then drop the cookies so a
// later, unrelated visit doesn't reuse them.
export function initLeadSourceApply() {
    var title = getCookie(COOKIE_TITLE);
    var source = getCookie(COOKIE_SOURCE);
    var email = getCookie(COOKIE_EMAIL);

    if (!title && !source && !email) {
        return;
    }

    if (title) {
        // Two sources for this value, two ways a line break shows up: the
        // "Lead Title" ACF field (inc/acf.php) is a plain textarea, so Enter
        // produces a real newline; Elementor's own Custom Attributes control
        // is one "attribute|value" per line, so a real newline there would
        // start a new attribute instead — a literal \n (backslash + n) has to
        // be typed instead. Both are normalized to <br> here. Rendered as
        // HTML rather than escaped to literal text so <b> etc. still work.
        var titleHtml = title.replace(/\r\n|\r|\n|\\n/g, '<br>');

        document.querySelectorAll('[data-lp-title-target]').forEach(function (el) {
            var target = el.querySelector('.elementor-heading-title') || el;
            target.innerHTML = titleHtml;
        });
    }

    if (source) {
        document.querySelectorAll('.lp-source-field input').forEach(function (input) {
            input.value = source;
        });
    }

    if (email) {
        document.querySelectorAll('.lp-email-field input').forEach(function (input) {
            input.value = email;
        });
    }

    deleteCookie(COOKIE_TITLE);
    deleteCookie(COOKIE_SOURCE);
    deleteCookie(COOKIE_EMAIL);
}
